module.exports = __webpack_public_path__ + "img/myNotice.fb6dc198.svg";